import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';

class WidgetIntro extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({ hideupdateDialog: false, hideAddDialog: false, hideAddFailedDialog: false, hideDeletePopup: false, });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };

    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchDataApi()
        this.dialogClose();
        // this.setState({
        // })
      }
    }];

    this.failedAddingButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchDataApi()
        this.dialogClose();

      }
    }];


    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteWidgetIntro()
        this.setState({ disabled: false })
        this.fetchDataApi()
      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
        this.fetchDataApi()
      }
    }];

    //for delete success
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.dialogInstance.hide();
        this.fetchDataApi()
        this.setState({ disabled: false })

      }
    }];

    this.state = {
      editedId: 0,
      fields: {},
      language: null,
      hidden: false,
      hideAddDialog: false,
      hideAddFailedDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
    }
  }
  editContent = event => {
    this.setState({ editedId: "-1" });
  }

  showPopup = () => {
    this.setState({
      hideDeletePopup: true
    })
  }

  handleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });
  }

  validateFields = () => {
    let fields = this.state.fields;
    let validateController = this;
    if (!fields["title"] || !fields["subTitle"]
      || !fields["introduction"] ||
      !fields["placeHolderMsg"] || !fields["botGreetings"]
    ) {
      this.notifyMsgFieldEmpty();
      validateController.setState({ editedId: "-1" })
      return false;
    }
    return true
  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please fill all the fields</b>, {
      position: "top-center"
    });
  }

  notifyFailToLoad() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }

  saveWidgetIntroApi = (props) => {
    props.preventDefault();
    let WidgetIntroController = this
    this.state.editedId = "0";
    this.setState(this.state);
    var data;

    if (this.validateFields(props)) {
      if (WidgetIntroController.state.fields.id === undefined) {


        data = {
          projectId: localStorage.getItem("currentProjectId"),
          language: document.getElementById("selectlanguage").value,
          title: this.state.fields['title'],
          subTitle: this.state.fields['subTitle'],
          introduction: this.state.fields['introduction'],
          placeHolderMsg: this.state.fields['placeHolderMsg'],
          botGreetings: this.state.fields['botGreetings']
        }
      }
      else {
        data = {
          projectId: localStorage.getItem("currentProjectId"),
          language: document.getElementById("selectlanguage").value,
          title: this.state.fields['title'],
          subTitle: this.state.fields['subTitle'],
          introduction: this.state.fields['introduction'],
          placeHolderMsg: this.state.fields['placeHolderMsg'],
          botGreetings: this.state.fields['botGreetings'],
          id: this.state.fields['id'],

        }
      }
      let widgetIntroController = this;
      $.ajax({
        url: "/api/widget-intro",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
        success: function (res) {
          if (res.success === true) {
            widgetIntroController.notifyAdd();
            widgetIntroController.fetchDataApi();
          } else {
            widgetIntroController.notifyFailToAdd(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      });
    }
  }

  notifyAdd() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Widget Introductory Added Successfully</b>, {
      position: "top-center",
    });
  }

  notifyFailToAdd(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  validateNewDataFields() {
    let fields = this.state.fields;
    if (!fields["newTitle"] && !fields["newSubTitle"]
      && !fields["newIntroduction"] &&
      !fields["newPlaceHolder"] && !fields["newBotGreeting"]
    ) {
      this.notifyMsgFieldEmpty();
      return false;
    }
    return true
  }


  fetchLanguagesApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var languageController = this;
    $.ajax(
      {
        url: "/api/project-languages-selected",
        async: false,
        method: 'GET',
        data: {
          projectId: projectId,
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            var loadlanguage = res.result;
            languageController.setState({ language: loadlanguage });
            var numberOfLanguages = loadlanguage.length;
            var ele3 = document.getElementById("selectlanguage");
            if (ele3 != null) {
              ele3.innerHTML = null;
              for (var i = 0; i < numberOfLanguages; i++) {
                ele3.innerHTML = ele3.innerHTML + '<option value="' + loadlanguage[i]['code'] +
                  '">' + loadlanguage[i]['name'] + '</option>';
              }
            }
            else {
              languageController.notifyFailToLoadLanguages();
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      }
    )
  }

  notifyFailToLoadLanguages() {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>Oops! Error occurred loading languages.Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }

  fetchDataApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var widgetIntroController = this;
    var selectedLanguage;
    if (document.getElementById('selectlanguage') != null) {
      selectedLanguage = document.getElementById('selectlanguage').value
    }
    $.ajax({
      url: "/api/widget-intro",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId,
        'language': selectedLanguage,
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var messages = res.result;
          if (messages === null) {
            document.getElementById("message-title").value = "";
            document.getElementById("subTitle").value = "";
            document.getElementById("introduction").value = "";
            document.getElementById("placeHolderMsg").value = "";
            document.getElementById("botGreetings").value = "";
            widgetIntroController.setState({
              fields: {},
              editedId: "0"
            })
          }
          else {
            widgetIntroController.setState({
              fields: messages
            })
          }
        }
        else {
          widgetIntroController.notifyFailToLoadData(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  notifyFailToLoadData(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  handleLangChange = (e) => {
    this.state.editedId = "0"
    this.fetchDataApi();
  }

  deleteWidgetIntro = () => {
    let WidgetIntroDeleteController = this
    let id = WidgetIntroDeleteController.state.fields.id;
    if (id == undefined) {
      WidgetIntroDeleteController.setState({
        hideDeletePopup: false,
      })
      WidgetIntroDeleteController.fetchDataApi();
      WidgetIntroDeleteController.notifyMsgDeleteSuccess();
    }
    else {
      $.ajax({
        url: "/api/widget-intro/" + id,
        async: false,
        method: 'DELETE',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {

          if (res.success === true) {
            WidgetIntroDeleteController.setState({
              hideDeletePopup: false,
            })
            WidgetIntroDeleteController.fetchDataApi();
            WidgetIntroDeleteController.notifyMsgDeleteSuccess();
            WidgetIntroDeleteController.state.editedId = "0";

          } else {
            WidgetIntroDeleteController.notifyFailToDelete(res.result);
            WidgetIntroDeleteController.state.editedId = "0";
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/";
          }
        }
      });
    }
  }

  notifyFailToDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }
  refreshMessages = () => {
    this.fetchDataApi();
    this.setState({ editedId: 0, fields: {} });

  }
  notifyMsgDeleteSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;Widget Introductory Deleted Successfully</b>, {
      position: "top-center"
    });
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchLanguagesApi();
      this.fetchDataApi();
    }, 300);

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.state.editedId = "0";
      if (document.getElementById('selectlanguage') != null) {
        thisController.fetchLanguagesApi(event.projectId);
        thisController.fetchDataApi(event.projectId);
      }
    });
  }

  render() {
    return (
      <div>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />

        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        {/* Select2 */}
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />

        {/* Main content */}
        <div className="content">
          <div className="container-fluid" style={{ marginTop: "-20px" }}>
            <div className="row">
              <div className="col-12">
                {/* Custom Tabs */}
                <div className="row">
                  <div className="col-sm-7">
                    <h6 className="nav-item" style={{ color: '#282a65', marginTop: '30px' }}>Widget Introductory</h6>
                    {/* <label className="page-title">
                  Widget Introductory
                    </label> */}

                  </div>
                  <div className="d-flex flex-row-reverse pt-2 col-sm-5">
                    <button className="btn action-button" style={{ marginTop: "6px" }}
                      title="Refresh" onClick={this.refreshMessages}>
                      <img src="./assets/images/refresh_white_24dp.png" />
                    </button>
                    <button type="button" className="btn action-button"
                      style={{ marginTop: "6px" }}
                      hidden={(this.state.editedId == 0) ? false : true}
                      onClick={this.editContent}><img src="./assets/images/edit2.png" />
                    </button>
                    <select className="input-group mb-3 form-control select2"
                      name="selectlanguage" id="selectlanguage"
                      style={{ width: '50%', marginTop: '12px', marginRight: '20px' }}
                      onChange={this.handleLangChange}>
                    </select>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body p-0 mb-25">
                  <div className="tab-content col-12 p-0">
                    <div className="card card-primary mt-3">
                      <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">
                        <div className="form-group ">
                          <label>Title</label>
                          <input disabled={(this.state.editedId == 0) ? true : false}
                            type="text" className={(this.state.editedId == 0) ? "form-control col-11 raise-form-input" : "form-control col-11"}
                            id="message-title" name="title" placeholder="Enter Title"
                            value={this.state.fields.title}
                            onChange={this.handleChange} style={{
                              border: '1px solid #D2D4DC',
                              borderRadius: '2px', padding: '0.375rem 0.75rem', width: '89.5%'
                            }} />
                        </div>
                        <div className="form-group">
                          <label>Sub Title</label>
                          <input disabled={(this.state.editedId == 0) ? true : false}
                            type="text" className={(this.state.editedId == 0) ? "form-control col-11 raise-form-input" : "form-control col-11"}
                            id="subTitle" name="subTitle" placeholder="Enter Sub Title"
                            value={this.state.fields.subTitle}
                            style={{ border: '1px solid #D2D4DC', borderRadius: '2px', padding: '0.375rem 0.75rem', width: '89.5%' }}
                            onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                          <label>Introduction</label>
                          <textarea className={(this.state.editedId == 0) ? "form-control col-11 raise-form-input" : "form-control col-11"}
                            disabled={(this.state.editedId == 0) ? true : false}
                            id="introduction" name="introduction"
                            value={this.state.fields.introduction}
                            rows={1} placeholder="Enter Introduction .." defaultValue={""}
                            style={{ border: '1px solid #D2D4DC', borderRadius: '2px', padding: '0.375rem 0.75rem', backgroundColor: 'white' }}
                            onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                          <label>Place Holder</label>
                          <input disabled={(this.state.editedId == 0) ? true : false}
                            type="text" className={(this.state.editedId == 0) ? "form-control col-11 raise-form-input" : "form-control col-11"}
                            id="placeHolderMsg" name="placeHolderMsg" placeholder="Enter Place Holder"
                            value={this.state.fields.placeHolderMsg}
                            style={{ border: '1px solid #D2D4DC', borderRadius: '2px', padding: '0.375rem 0.75rem', width: '89.5%' }}
                            onChange={this.handleChange} />
                        </div>

                        <div className="form-group">
                          <label>Agent Greetings</label>
                          <textarea disabled={(this.state.editedId == 0) ? true : false}
                            type="text" className={(this.state.editedId == 0) ? "form-control col-11 raise-form-input" : "form-control col-11"}
                            id="botGreetings" name="botGreetings" placeholder="Enter Agent Greetings"
                            value={this.state.fields.botGreetings}
                            rows={1}
                            style={{ border: '1px solid #D2D4DC', borderRadius: (this.state.editedId == 0) ? '2px' : "none", padding: '0.375rem 0.75rem' }}
                            onChange={this.handleChange} />
                        </div>


                        <div className="form-group col-12" Align="center">
                          <label className="col-12 pull-left" />
                          <button type="button" className="btn btn-primary navyblue-btn"
                            style={{ width: "15%" }}
                            hidden={(this.state.editedId == 0) ? true : false}
                            onClick={this.saveWidgetIntroApi}>Save</button>
                          <button type="button" className="btn btn-primary navyblue-btn"
                            style={{ width: "15%" }}
                            hidden={(this.state.editedId == 0) ? true : false}

                            onClick={this.showPopup}
                          >Delete</button>
                        </div>

                        <ToastContainer className="Toast-at-center" />
                        {/* Dialog Component For Deletion Confirmation */}
                        <DialogComponent width='400px' animationSettings={this.settings}
                          header='Delete Question' showCloseIcon={true} buttons={this.buttons}
                          ref={dialog => this.dialogInstance = dialog}
                          visible={this.state.hideDeletePopup} close={this.dialogClose}>
                          <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete the Widget Intro??&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          Press 'Yes' to delete or press 'No' to decline..</DialogComponent>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default WidgetIntro;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/WidgetIntro.js